export default "__VITE_ASSET__BkchVDMk__"